export default {
  postIdentifyCode(options) {
    return this.http('Passport', 'post', '/api/v1/register/send_cellphone_verification.json', options)
      .then((res) => {
        return res;
      });
  },

  checkIdentifyCode(options) {
    return this.http('Passport', 'post', '/api/v1/register/verify_cellphone', options)
      .then((res) => {
        return res;
      });
  },

  getUserRegisterMes(options) {
    return this.http('Passport', 'post', '/api/v1/register/by_cellphone', options)
      .then((res) => {
        return res;
      });
  },

  getSaIdentity() {
    return this.http('api', 'get', '/open-interface/v1/data/report_distinct')
      .then((res) => {
        return res;
      });
  }
};
